import { AccommodationExtraApiDto, ExtrasSummaryApiDto, PremiumActivitiesExtraApiDto } from '@lx/shared/api';
import { Accommodation } from './accommodation.type';

export type PremiumActivities = PremiumActivitiesExtraApiDto;
export type ExtrasSummary = Omit<ExtrasSummaryApiDto, 'accommodations'> & {
  accommodations?: Accommodation[];
};
export type ReducedAccommodation = AccommodationExtraApiDto;
